import React from "react";
import { updateOrCreateCampaign, pullCampaigns } from "../../../store/api/calls";
import DataTable from "../../theme/tables/DataTable";
import BaseModal from "../../theme/modals/BaseModal";
import BaseForm from "../../theme/forms/BaseForm";

class CampaignsTab extends React.Component {
  constructor(props) {
    super(props);
    // TODO: get campaigns from user account
    this.state = {
      editModalOpen: false,
      editModalErrorMsg: null,
      deleteModalOpen: false,
      editingInstance: {},
      formInputs: [],
    };
  }

  componentDidUpdate(prevProps) {
    // If we navigated here from editing focused campaign, open the edit modal
    if (prevProps.focusedCampaign !== this.props.focusedCampaign && this.props.focusedCampaign) {
      this.onOpenEditModal(this.props.focusedCampaign);
    }
  }

  _filterKeysForCampaignDataTable = () => {
    return this.props.campaigns.map((d) => ({
      name: d.name,
      description: d.description,
      _data: d,
    }));
  };

  _generateFormInputs = (modelInstance) => {
    return [
      {
        type: "text",
        title: "Name",
        dataKey: "name",
        value: modelInstance?.name,
        placeholder: "Client",
      },
      {
        type: "text",
        title: "Description",
        dataKey: "description",
        value: modelInstance?.description,
        placeholder: "Where is it and what are we doing there?",
      },
    ];
  };

  onOpenEditModal = (modelInstance = {}, creating = false) => {
    this.setState({
      formInputs: this._generateFormInputs(modelInstance),
      editModalOpen: true,
      editingInstance: modelInstance,
    });
  };

  onCloseEditModal = () => {
    this.setState({
      editModalOpen: false,
      editingInstance: {},
      editModalErrorMsg: null,
    });
  };

  onOpenDeleteModal = (modelInstance = {}) => {
    this.setState({ deleteModalOpen: true, editingInstance: modelInstance });
  };

  onCloseDeleteModal = () => {
    this.setState({ deleteModalOpen: false, editingInstance: {} });
  };

  handleUpdateCreateSubmission = (data) => {
    const id = this.state.editingInstance.id;
    if (id) data = { ...data, id };

    updateOrCreateCampaign(data)
      .then(() => {
        this.onCloseEditModal();
        this.props.showSuccess();
      })
      .catch((err) => {
        this.props.setError("Failed to update campaign");
      });
  };

  handleRemoveSubmission = () => {
    const id = this.state.editingInstance.id;
    updateOrCreateCampaign({ is_active: false, id }).then(this.onCloseDeleteModal);
  };

  render() {
    return (
      <div>
        <div className="button-table-top-wrapper">
          <a className="button" onClick={() => this.onOpenEditModal({}, true)}>
            + Add Campaign
          </a>
        </div>

        <DataTable
          data={this._filterKeysForCampaignDataTable()}
          title="Campaigns"
          actions={[
            {
              title: "edit",
              icon: "fa-edit",
              action: (modelInstance) => this.onOpenEditModal(modelInstance),
            },
            {
              title: "Remove",
              icon: "fa-minus-square",
              action: this.onOpenDeleteModal,
            },
          ]}
        />

        <BaseModal
          open={this.state.editModalOpen}
          onClose={this.onCloseEditModal}
          center
        >
          <BaseForm
            inputs={this.state.formInputs}
            onCancel={this.onCloseEditModal}
            onSubmit={this.handleUpdateCreateSubmission}
          />
          {!!this.state.editModalErrorMsg && (
            <div className="danger-text flx center">
              {this.state.editModalErrorMsg}
            </div>
          )}
        </BaseModal>

        <BaseModal
          open={this.state.deleteModalOpen}
          onClose={this.onCloseDeleteModal}
          center
        >
          <div className="modal-internal-wrapper">
            <p>
              Are you sure you want to remove the campaign{" "}
              {this.state.editingInstance.name}?
            </p>
            <div className="button-wrapper">
              <div className="button" onClick={this.handleRemoveSubmission}>
                Remove
              </div>
              <div
                className="button button-outline"
                onClick={this.onCloseDeleteModal}
              >
                Cancel
              </div>
            </div>
          </div>
        </BaseModal>
      </div>
    );
  }
}

export default CampaignsTab; 